export const volumeConfig: any = {
  setTextureSize4X: true,
};
